import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from '../../icons';
import { useMemo } from 'react';
export function YearPicker({ value, onChange }) {
    const yearRange = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 30;
        const endYear = currentYear + 5;
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
            years.push(year);
        }
        return years;
    }, []);
    return (_jsx("div", { className: "relative", children: _jsxs("div", { className: "flex items-center gap-stack-dense", children: [_jsx("select", { value: value, onChange: (e) => {
                        const year = parseInt(e.target.value, 10);
                        onChange(year);
                    }, className: "appearance-none bg-transparent py-stack-dense px-stack-tight text-body-sm text-fg-muted font-medium cursor-pointer rounded-control-sm hover:bg-bg-subtle focus:outline-none focus:ring-2 focus:ring-brand pr-stack-section", children: yearRange.map(year => (_jsx("option", { value: year, children: year }, year))) }), _jsx(ChevronDownIcon, { className: "size-3.5 text-fg-subtle absolute right-2 pointer-events-none" })] }) }));
}
